module.exports = __webpack_public_path__ + "img/ts1.bd1fe56a.png";